module.exports = __webpack_public_path__ + "img/03.e44c8a04.jpg";